import Lazyload from 'vue-lazyload';

export default Lazyload;


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/lazyload/index.js
// module id = 229
// module chunks = 81